var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemesTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.429,
    height: 21.429,
    viewBox: "0 0 21.429 21.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-layout",
    "data-name": "Icon feather-layout",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M6.77,4.5H22.659a2.27,2.27,0,0,1,2.27,2.27V22.659a2.27,2.27,0,0,1-2.27,2.27H6.77a2.27,2.27,0,0,1-2.27-2.27V6.77A2.27,2.27,0,0,1,6.77,4.5Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#7119bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M4.5,13.5H24.929",
    transform: "translate(-4.5 -6.69)",
    fill: "none",
    stroke: "#7119bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M13.5,27.119V13.5",
    transform: "translate(-6.69 -6.69)",
    fill: "none",
    stroke: "#7119bf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemesTool);
export default __webpack_public_path__ + "static/media/themes_tool.9b828d72d2092133c3a408556696ea2a.svg";
export { ForwardRef as ReactComponent };